<template>
  <page-wrapper background="/static/img/page-key-words-result/1113.png">
    <div class="top" swiper-animate-effect="animate__fadeIn">
      <div class="area">
        <span class="text-highline">{{customerName}}</span>老师<br />
        您下半年的科研关键词是:<br />
      </div>
    </div>
    <div class="key-word">{{text}}</div>
<!--    <img class="pics-1" src="/static/img/page-key-words-result/4.png" />-->
<!--    <img class="code" src="/static/img/page-key-words-result/code.png" />-->
  </page-wrapper>
</template>
<script>
import PageWrapper from '../PageWrapper.vue'
import { mapGetters } from 'vuex'
export default {
  components: { PageWrapper },
  methods: {
    handleButtonClick () {
      this.swiper.slideNext()
    }
  },
  computed: {
    ...mapGetters(['customerName'])
  },
  props: [
    'swiper'
  ],
  data () {
    return {
      texts: ['未来可期', '差异显著', '文章见刊', '经费充足', '文章接收', '科研大吉', '逢投必中', '数据分析好到爆', '科研人 科研魂', '好运爆表100%', '沉迷学术 无法自拔', '论文一稿过', '多发paper 少掉头发'],
      text: ''
    }
  },
  created () {
    this.text = this.texts[Math.floor(Math.random() * 3)]
  }
}

</script>
<style lang="less" scoped>
.page-wrapper {
  .main-title {
    position: absolute;
    left: 38.304vw;
    top: 27.93vw;
    width: 23.142vw;
    height: 12.502vw;
    opacity: 1;
  }
  .key-word {
    position: absolute;
    left: 50%;
    margin-left: -80px;
    top: 79.8vw;
    //width: 55.062vw;
    height: 34.58vw;
    opacity: 1;

    font-family: Source Han Sans;
    font-size: 40px;
    font-weight: bold;
    line-height: 49px;
    text-align: center;
    display: flex;
    align-items: center;
    letter-spacing: 0em;

    font-variation-settings: "opsz" auto;
    font-feature-settings: "kern" on;
    color: #FFFFFF;

  }
 .top {
   position: absolute;
   left: 3.458vw;
   top: 25.8vw;
   width: 93.477vw;
   height: 127.414vw;
   opacity: 1;
   .area {
     position: absolute;
     left: 5.04vw;
     width: 80.598vw;
     height: 19.388vw;
     opacity: 1;

     font-family: Source Han Sans;
     font-size: 16px;
     font-weight: 350;
     line-height: 35px;
     letter-spacing: -0.3px;

     color: #193543;

     ///* 李晓萌 */
     //font-family: Source Han Sans;
     //font-weight: 700;
     //font-size: 22px;
     //
     ///* 老师您下半年的科研关键词是： */
     //font-family: Source Han Sans;
     //font-weight: 350;
     //font-size: 16px;
   }
 }
  .friends {
    position: absolute;
    left: 28.462vw;
    top: 121.828vw;
    width: 42.826vw;
    height: 11.704vw;
    opacity: 1;

    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 350;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.3px;

    color: #193543;
  }
  .code {
    position: absolute;
    left: 9.576vw;
    top: 176vw;
    width: 20.157vw;
    height: 20.157vw;
    opacity: 1;
  }
  .code-1 {
    position: absolute;
    top: 180vw;
    left: 35.93vw;
    width: 48.412vw;
    height: 14.364vw;
    opacity: 1;

    font-family: Source Han Sans;
    font-size: 16px;
    font-weight: 350;
    line-height: 27px;
    letter-spacing: -0.3px;

    color: #3D3D3D;
  }
  .final {
    position: absolute;
    left: 9.31vw;
    top: 201.362vw;
    width: 84.588vw;
    height: 3.99vw;
    opacity: 1;

    font-family: Source Han Sans;
    font-size: 10px;
    font-weight: 350;
    line-height: 15px;
    letter-spacing: -0.3px;

    color: rgba(93, 133, 234, 0.66);

  }
  .pics-1 {
    position: absolute;
    left: 48.944vw;
    top:125.02vw;
    width: 50.54vw;
    height: 50.54vw;
    opacity: 1;
  }
  .text-highline {
    font-size: 22px;
    font-weight: 600;
  }
  .main-button {
    width: 73.86vw;
    height: 17.86vw;
    position: absolute;
    left: 50%;
    margin-left: -36.93vw;
    bottom: 36vw;
  }

  .brand-area {
    position: absolute;
    left: 7.182vw;
    top: 170vw;
    width: 82.46vw;
    height: 32.186vw;
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?2840abc6